import React from "react";
import { NavLink } from "react-router-dom";
import "./BottomNav.css";

const svgProps = { width: 22, height: 22, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" };

function HomeIcon() {
  return (
    <svg {...svgProps}>
      <path d="M3 10.5L12 3l9 7.5V21a1 1 0 01-1 1H4a1 1 0 01-1-1V10.5z" />
      <path d="M9 22V13h6v9" />
    </svg>
  );
}

function BenefitsIcon() {
  return (
    <svg {...svgProps}>
      <rect x="3" y="10" width="18" height="11" rx="1.5" />
      <path d="M12 10V3" />
      <path d="M12 3c-2 0-4 1.5-4 3.5S10 10 12 10" />
      <path d="M12 3c2 0 4 1.5 4 3.5S14 10 12 10" />
      <path d="M3 14.5h18" />
      <path d="M12 10v11" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <line x1="2" y1="10" x2="22" y2="10"/>
    </svg>
  );
}

function BankingIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="8" cy="8" r="3"/>
      <circle cx="16" cy="8" r="3"/>
      <circle cx="8" cy="16" r="3"/>
      <circle cx="16" cy="16" r="3"/>
    </svg>
  );
}

const tabs = [
  { to: "/", icon: HomeIcon, label: "Home" },
  { to: "/benefits", icon: BenefitsIcon, label: "Benefits" },
  { to: "/card", icon: CardIcon, label: "Card" },
  { to: "/banking", icon: BankingIcon, label: "Hub" },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav">
      {tabs.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === "/"}
            className={({ isActive }) =>
              `bottom-nav-item ${isActive ? "active" : ""}`
            }
          >
            <span className="nav-icon"><Icon /></span>
            <span className="nav-label">{t.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
